import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, EmptyState, GridCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function NoData(props) {
    const { reset } = props;
    return (<GridCell style={{ gridColumn: 'span 12', gridRow: 'span 3' }}>
      <EmptyState withAvatar icon={<Falcon icon="search"/>} title={t({
            message: 'No contacts found',
            comment: 'Contact library list - Empty state - title',
        })} description={t({
            message: 'There are no contacts that match your current search.',
            comment: 'Contact library list - Empty state - description',
        })} actions={<Button type="button" onClick={reset} appearance="secondary" size="small">
            <Trans comment="Contact library list - Error state - Try again button label">Reset search</Trans>
          </Button>}/>
    </GridCell>);
}
